import ToggleTheme from "./ToggleTheme";

const Navbar = () => {
  return (
    <div className="flex flex-col items-center justify-between w-full p-4 pt-4 sm:flex-row max-w-[1200px]">
      <div className="text-4xl dark:text-textHeading font-logo">
        WB<span className="animate-pulse dark:text-highlight">.</span>
      </div>
      <nav className="">
        <ul className="flex items-center gap-8">
          <li>
            <button
              className="dark:text-textHeading text-gray-900 after:h-[2px] after:w-0 after:bg-gray-900 dark:after:bg-highlight after:block after:hover:w-full after:ease-in after:duration-300 tracking-widest font-semibold hover:opacity-70 transition-opacity"
              onClick={() => window.scrollTo(0, 860)}>
              Projects
            </button>
          </li>
          <ToggleTheme />
          <li>
            <a
              className="dark:text-textHeading text-gray-900 after:h-[2px] after:w-0 after:bg-gray-900 dark:after:bg-highlight after:block after:hover:w-full after:ease-in after:duration-300 tracking-widest font-semibold hover:opacity-70 transition-opacity"
              href="mailto:blanck.william@gmail.com"
              target="_blank"
              rel="noreferrer">
              Contact
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Navbar;
